module.exports = __webpack_public_path__ + "media/images/log/log-icon-5d55b3a9abb6ca5f680eada77b136f78.svg";